module.exports = __webpack_public_path__ + "img/fantasy.cf59013b.png";